import React, { Component } from "react";
import logo from "../../../../assets/Logo.png";
import numberOfQualifiedLeads from "../../../../assets/number-of-qualified-leads.svg";

import {
  MainContainer,
  FormWrapper,
  FormColumn,
  FormRow,
  Title,
  Form,
  FormInput,
  FormInputSelect,
  FormInputSelectOption,
  ContentWrapper,
  SubContainer,
  ButtonSuccess,
} from "../../styles";

class RegisterVerification extends Component {
  state = {
    chooseRoleFormInputSelect: [
      "Customer Support",
      "Engineering",
      "CEO/Owner/Founder/Director",
      "Product Management",
      "Marketing",
      "Sales",
      "Others",
      "Student",
    ],
    employeeSizeFormInputSelect: [
      "Below 20",
      "21 to 50",
      "51 to 200",
      "201 to 500",
      "Above 500",
    ],
    industryTypeFormInputSelect: [
      "eCommerce",
      "IT & Automation",
      "Banking/Finance/Insurance/Legal",
      "Education",
      "Health & Wellness",
      "Others",
    ],
    customerQueriesFormInputSelect: [
      "upto 2000",
      "2000 to 10000",
      "10000 to 25000",
      "25000+",
      "Not Sure",
    ],
    verificationPageData: {
      password: "",
      role: "",
      employeeSize: "",
      industryType: "",
      customerQueriesPerMonth: "",
    },
    confirmPassword: "",
    OTPfromUser: "",
    isOTPverified: false,
  };

  handleOTPChange = (event) => {
    this.setState({ OTPfromUser: event.currentTarget.value });
  };
  OTPSubmit = (event) => {
    if (this.state.OTPfromUser.length === 6) {
      event.preventDefault();
      if (
        this.state.OTPfromUser === window.sessionStorage.getItem("OTPToVerify")
      ) {
        this.setState({ isOTPverified: true });
        window.sessionStorage.removeItem("OTPToVerify");
      } else {
        alert(`unable to verify OTP, Please Try Again !!`);
      }
    }
  };
  verifiedSignUpFromSubmit = (event) => {
    event.preventDefault();
    let verificationPageData = { ...this.state.verificationPageData };
    if (this.state.confirmPassword === verificationPageData.password) {
      this.props.propsToContainer(this.state.verificationPageData);
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainContainer>
          <SubContainer>
            <ContentWrapper
              style={this.state.isOTPverified ? { display: "none" } : {}}
            >
              <img src={logo} style={{ width: "125px" }} alt="logo" />
              <img
                className="chatBotSvg"
                src={numberOfQualifiedLeads}
                style={{ marginTop: "40px", width: "300px" }}
                alt=""
              />
            </ContentWrapper>
            <FormWrapper
              style={{ marginTop: "10vh", minHeight: "fit-content" }}
            >
              <FormColumn
                style={{
                  padding: "35px 60px",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Title style={{ margin: "0px 0px 32px" }}>
                  Complete Sign-Up Verification
                </Title>
                <FormRow
                  style={
                    this.state.isOTPverified
                      ? {}
                      : { columnGap: "0vw", rowGap: "0vh" }
                  }
                >
                  <Form>
                    <FormInput
                      type="text"
                      required={true}
                      placeholder="(OTP) / One Time Password"
                      onChange={this.handleOTPChange}
                    ></FormInput>
                    <ButtonSuccess
                      onClick={this.OTPSubmit}
                      style={{ margin: "24px 0px" }}
                    >
                      Verify OTP
                    </ButtonSuccess>
                    <FormInput
                      type={this.state.isOTPverified ? "password" : "hidden"}
                      required={true}
                      placeholder="Password"
                      onChange={(event) => {
                        let verificationPageData = {
                          ...this.state.verificationPageData,
                        };
                        verificationPageData.password =
                          event.currentTarget.value;
                        this.setState({
                          verificationPageData,
                        });
                      }}
                    ></FormInput>
                    <FormInput
                      type={this.state.isOTPverified ? "password" : "hidden"}
                      required={true}
                      placeholder="Confirm Password"
                      onChange={(event) => {
                        this.setState({
                          confirmPassword: event.currentTarget.value,
                        });
                      }}
                    ></FormInput>
                  </Form>
                  <Form style={{ alignItems: "flex-start" }}>
                    {/* <FormInputLabel>Choose your role: (Optional)</FormInputLabel> */}
                    <FormInputSelect
                      disabled={!this.state.isOTPverified}
                      onChange={(event) => {
                        let verificationPageData = {
                          ...this.state.verificationPageData,
                        };
                        verificationPageData.role = event.currentTarget.value;
                        this.setState({
                          verificationPageData,
                        });
                      }}
                      style={
                        this.state.isOTPverified
                          ? this.state.verificationPageData.employeeSize === ""
                            ? {}
                            : { color: "rgb(44,56,63)" }
                          : { display: "none" }
                      }
                    >
                      <FormInputSelectOption value="" selected disabled hidden>
                        Choose your role (optional)
                      </FormInputSelectOption>
                      {this.state.chooseRoleFormInputSelect.map((value) => (
                        <FormInputSelectOption key={value} value={value}>
                          {value}
                        </FormInputSelectOption>
                      ))}
                    </FormInputSelect>
                    <FormInputSelect
                      disabled={!this.state.isOTPverified}
                      onChange={(event) => {
                        let verificationPageData = {
                          ...this.state.verificationPageData,
                        };
                        verificationPageData.employeeSize =
                          event.currentTarget.value;
                        this.setState({
                          verificationPageData,
                        });
                      }}
                      style={
                        this.state.isOTPverified
                          ? this.state.verificationPageData.employeeSize === ""
                            ? {}
                            : { color: "rgb(44,56,63)" }
                          : { display: "none" }
                      }
                    >
                      <FormInputSelectOption value="" selected disabled hidden>
                        Employee size of your company (optional)
                      </FormInputSelectOption>
                      {this.state.employeeSizeFormInputSelect.map((value) => (
                        <FormInputSelectOption key={value} value={value}>
                          {value}
                        </FormInputSelectOption>
                      ))}
                    </FormInputSelect>
                    <FormInputSelect
                      disabled={!this.state.isOTPverified}
                      onChange={(event) => {
                        let verificationPageData = {
                          ...this.state.verificationPageData,
                        };
                        verificationPageData.industryType =
                          event.currentTarget.value;
                        this.setState({
                          verificationPageData,
                        });
                      }}
                      style={
                        this.state.isOTPverified
                          ? this.state.verificationPageData.employeeSize === ""
                            ? {}
                            : { color: "rgb(44,56,63)" }
                          : { display: "none" }
                      }
                    >
                      <FormInputSelectOption value="" selected disabled hidden>
                        Select industry type (optional)
                      </FormInputSelectOption>
                      {this.state.industryTypeFormInputSelect.map((value) => (
                        <FormInputSelectOption key={value} value={value}>
                          {value}
                        </FormInputSelectOption>
                      ))}
                    </FormInputSelect>
                    <FormInputSelect
                      disabled={!this.state.isOTPverified}
                      onChange={(event) => {
                        let verificationPageData = {
                          ...this.state.verificationPageData,
                        };
                        verificationPageData.customerQueriesPerMonth =
                          event.currentTarget.value;
                        this.setState({
                          verificationPageData,
                        });
                      }}
                      style={
                        this.state.isOTPverified
                          ? this.state.verificationPageData.employeeSize === ""
                            ? {}
                            : { color: "rgb(44,56,63)" }
                          : { display: "none" }
                      }
                    >
                      <FormInputSelectOption value="" selected disabled hidden>
                        No of customer queries you get /month (optional)
                      </FormInputSelectOption>
                      {this.state.customerQueriesFormInputSelect.map(
                        (value) => (
                          <FormInputSelectOption key={value} value={value}>
                            {value}
                          </FormInputSelectOption>
                        )
                      )}
                    </FormInputSelect>
                  </Form>
                </FormRow>
                <ButtonSuccess
                  disabled={!this.state.isOTPverified}
                  style={
                    this.state.isOTPverified
                      ? { textTransform: "uppercase", marginTop: "40px" }
                      : {
                          textTransform: "uppercase",
                          marginTop: "40px",
                          backgroundColor: "rgb(159,159,159)",
                          cursor: "default",
                          display: "none",
                        }
                  }
                  onClick={this.verifiedSignUpFromSubmit}
                >
                  Complete Sign-Up
                </ButtonSuccess>
              </FormColumn>
            </FormWrapper>
          </SubContainer>
        </MainContainer>
      </React.Fragment>
    );
  }
}

export default RegisterVerification;
